import { getItemStepz } from 'src/helpers/localstorage';
import API from './config';
import PAGOS_ENDPOINT from './endpoint';


//catch error
const catchError = (error) => {
    if (error.response) {
        /* 
        * Se hizo la solicitud y el servidor respondió con un
        * código de estado que cae fuera del rango de 2xx
        */
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        return { ...error.response.data,status: error.response.status, descripcion: 'Error Response', error: true };
    } else if (error.request) {
        /*
        * se realizó la solicitud pero no se recibió respuesta, `error.request`
        * es una instancia de XMLHttpRequest en el navegador y una instancia
        * de http.ClientRequest en Node.js 
        * */
        return { ...error.request, descripcion: 'Error Request', error: true };
    } else {
        // Algo sucedió al configurar la solicitud y provocó un error
        // console.log('Error', error.message);
        return { ...error.message, error: true };
    }
}

// CREAR URL DE ACCESO
export const postURLAcceso = async (identificacion) => {

    try {
        const response = API({
            method: 'POST',
            url: PAGOS_ENDPOINT.URLDEACCESO,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                identificacion
            }
        });

        const { data } = await response;
        return data;

    } catch (error) {
        let data = catchError(error);
        return data;
    }

}

// VALIDA URL DE ACCESO PASARELA DE PAGO FEDPA
export const getValidaURLAcceso = async ({
    token,
    idacceso
}) => {

    try {

        const response = API({
            method: 'GET',
            url: PAGOS_ENDPOINT.VALIDARURLACCESO,
            headers: {
                'Content-Type': 'application/json',
                token: token,
                idacceso: idacceso
            }
        });

        const { data } = await response;
        return data;

    } catch (error) {
        let data = catchError(error);
        return data;
    }

}

// LISTA DE POLIZA A PAGAR
export const getPolizas = async (identificacion) => {

    try {

        // console.log(getItemStepz()?.idAcceso);

        const response = API({
            method: 'GET',
            url: PAGOS_ENDPOINT.POLIZAS,
            params: {
                identificacion
            },
            headers: {
                'Content-Type': 'application/json',
                token: getItemStepz()?.token,
                idacceso: getItemStepz()?.idAcceso
            }
        });

        const { data } = await response;
        return data;

    } catch (error) {
        let data = catchError(error);
        return data;
    }
}

// export const postPolizaPagar = async (datos) => {
//     try {

//         const response = API({
//             method: 'POST',
//             url: PAGOS_ENDPOINT.GUARDARPOLIZAPAGAR,
//             headers: {
//                 'Content-Type': 'application/json',
//                 token: getItemStepz()?.token,
//                 idacceso: getItemStepz()?.idAcceso
//             },
//             data: JSON.stringify(datos)
//         });

//         const { data } = await response;
//         return data;

//     } catch (error) {
//         let data = catchError(error);
//         return data;

//     }
// }

// ** PROCESAR PAGO
export const postProcesarPago = async (datos) => {
    try {
        const response = API({
            method: 'POST',
            url: PAGOS_ENDPOINT.PROCESARPAGO,
            headers: {
                'Content-Type': 'application/json',
                token: getItemStepz()?.token,
                idacceso: getItemStepz()?.idAcceso
            },
            data: JSON.stringify(datos)
        });

        const { data } = await response;
        return data;

    } catch (error) {
        let data = catchError(error);
        return data;
    }
}

// ** DETALLE DE PAGO
export const getDetallePago = async () => {
    try {
        const response = API({
            method: 'GET',
            url: PAGOS_ENDPOINT.DETALLEPAGO,
            headers: {
                'Content-Type': 'application/json',
                token: getItemStepz()?.token,
                idacceso: getItemStepz()?.idAcceso
            }
        });

        const { data } = await response;
        return data;

    } catch (error) {
        let data = catchError(error);
        return data;

    }

}


export const putActualizacionDatosAcceso = async (datos) => {
    try {
        const response = API({
            method: 'PUT',
            url: PAGOS_ENDPOINT.ACTUALIZACIONDATOSACCESO,
            headers: {
                'Content-Type': 'application/json',
                token: getItemStepz()?.token,
                idacceso: getItemStepz()?.idAcceso
            },
            data: JSON.stringify(datos)
        });

        const { data } = await response;
        return data;

    } catch (error) {
        let data = catchError(error);
        return data;

    }

}